import { useNavigate, useParams } from "react-router-dom";
import CardHeader from "../../../antd/components/CardHeader";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { Collapse, InputGroup } from "react-bootstrap";
import { useContext, useEffect, useState } from "react";
import CurrencyInput from 'react-currency-input-field';
import Select from 'react-select';
import './styles.css';
import { ISelectProps } from "../../../Interfaces/ISelectProps";
import { AllEligibleType } from "../../../Utils/AllEligibleType";
import useLoading from "../../../Hooks/useLoading";
import Loader from "../../../Components/Shared/Loader";
import { IResponseProps } from "../../../Interfaces/IResponseProps";
import { toast } from "react-toastify";
import { CompanyContext } from "../../../Contexts/CompanyContext";
import { ProjectHistoryModel } from "../../../Models/ProjectHistoryModel";
import { EditProjectHistoryAPI, GetProjectHistoryAPI } from "../../../API/ProjectHistoryAPI";
import { AuthContext } from "../../../Contexts/AuthContext";
import { AllStatus } from "../../../Utils/AllContratTypes";
import ModalConfirmHistoricComponent from "../../../Components/ProjectInformations/ModalConfirmHistoricComponent";
import useModal from "../../../Hooks/useModal";
import useCan from "../../../Hooks/useCan";
import { Button, TextField } from "@mui/material";

const EditProjectHistory = () => {
    const { projectId } = useParams();
    const { showModal, toggleShowModal } = useModal();
    const { company } = useContext(CompanyContext);
    const { userEmail } = useContext(AuthContext);
    const { loading, toggleLoading } = useLoading();
    const [open, setOpen] = useState<boolean>(false);
    const [budget, setBudget] = useState<string>("0");
    const [RhValue, setRhValue] = useState<string>("0");
    const [infraValue, setInfraValue] = useState<string>("0");
    const [invoicesValue, setInvoicesValue] = useState<string>("0");
    const [equipmentValue, setEquipmentValue] = useState<string>("0");
    const [projectName, setProjectName] = useState<string>("");
    const [activities, setActivities] = useState<string>("");
    const [eligible, setEligible] = useState<ISelectProps>();
    const [eligibleText, setEligibleText] = useState<string>("");
    const [inProgress, setInProgress] = useState<boolean>(false);
    const [changing, setChanging] = useState<string>("");
    const [project, setProject] = useState<ProjectHistoryModel>({} as ProjectHistoryModel);
    const [continueResp, setContinueResp] = useState<boolean>(false);
    const [changingValue, setChangingValue] = useState<any>();
    const navigate = useNavigate();
    const CanView = useCan({ rolesCan: ["Manager", "Consultant"] })

    const sumBudget = () => {
        let result = parseFloat(RhValue.replace(",", ".")) + parseFloat(infraValue.replace(",", ".")) + parseFloat(invoicesValue.replace(",", ".")) + parseFloat(equipmentValue.replace(",", "."));

        setBudget(result.toFixed(2).toString());
    }

    const setZeroForAll = () => {
        let result = parseFloat(RhValue) + parseFloat(infraValue) + parseFloat(invoicesValue) + parseFloat(equipmentValue);

        if (result != parseFloat(budget)) {
            setRhValue("0");
            setEquipmentValue("0");
            setInfraValue("0");
            setInvoicesValue("0");
        }
    }

    const setAllInformations = (project: ProjectHistoryModel) => {
        setProject(project);
        setProjectName(project.name);
        setEquipmentValue(project.equipmentValue.toString());
        setActivities(project.activities);
        setInfraValue(project.infraValue.toString());
        setInvoicesValue(project.invoiceValue.toString());
        setRhValue(project.rhValue.toString());
        setEligible(AllEligibleType[project.eligibleType]);
        setEligibleText(AllEligibleType[project.eligibleType].value);
        setInProgress(project.inProgress);

        sumBudget();


        if (project.budget != 0 && parseFloat(budget) == 0) {
            setBudget(project.budget.toString());
        }
    }

    const getProjectInfo = async (id: string) => {
        try {
            toggleLoading(true);

            await GetProjectHistoryAPI(id).then((resp: IResponseProps) => {
                if (resp.statusCode == 200) {
                    const project = resp.data as ProjectHistoryModel;
                    if (project) {
                        setAllInformations(project);
                    }
                }
            }).finally(() => {
                toggleLoading(false);
            });
        } catch (error: any) {
            toast.error(error);
            toggleLoading(false);
        }
    }

    const Submit = async () => {
        try {
            toggleLoading(true);

            await EditProjectHistoryAPI(projectId ?? "", userEmail, projectName, activities, budget.replace(",", "."), RhValue.replace(",", "."), equipmentValue.replace(",", "."), invoicesValue.replace(",", "."), infraValue.replace(",", "."), eligibleText, company.id, inProgress).then((resp: IResponseProps) => {
                if (resp.statusCode === 200) {
                    toast.success(`Projeto ${projectName} editado com sucesso!`);
                    navigate(`/projectInformation/${company.id}`);
                }
            }).finally(() => {
                toggleLoading(false);
            });
        }
        catch (error: any) {
            toast.error(error);
            toggleLoading(false);
        }
    }

    useEffect(() => {
        if (projectId != "") {
            getProjectInfo(projectId ?? "");
        }
    }, [projectId]);

    useEffect(() => {
        if (changing != "") {
            toggleShowModal();
        }
    }, [changing]);

    useEffect(() => {
        if (continueResp) {
            if (changing == "eligible") {
                setEligible(changingValue);
                setEligibleText(changingValue.value);
                setContinueResp(false);
            } else {
                setInProgress(false);
                setContinueResp(false);
            }
        } else {
            setChanging("");
        }
    }, [continueResp]);

    return (
        <div className='card ml-2 mr-2'>
            {loading && <Loader />}
            <CardHeader
                pageName={"Editar Projeto"}
                hasPageBefore={true}
                linkPageBefore={`/projectInformation/${company.id}`}
                pageBeforeName={"Informações de Projetos"}
            />
            <ModalConfirmHistoricComponent
                setResponse={setContinueResp}
                show={showModal}
                toggleShow={toggleShowModal}
                changing={changing}
            />
            <div className='card-body mt-2 ps-4 pe-4'>
                <form autoComplete='false' id="formProjects" method='PUT'>
                    <div className="mb-4">
                        
                        <TextField label="Nome do Projeto a Apresentar:" value={projectName} onChange={(e: any) => setProjectName(e.target.value)} className='form-control mt-2' placeholder="Insira um nome.." />
                    </div>
                    <div className="mb-4  mt-2">
                       
                        <TextField label="Atividades Associadas ao Projeto:" multiline required value={activities} onChange={(e: any) => setActivities(e.target.value)} className="form-control mt-2" placeholder="Insira as atividades.." rows={5} />
                    </div>
                    <div className="mb-4 mt">
                        <label className="required">Orçamento Estimado do Projeto: </label>
                        <div className='border-round-in-top card-header d-flex align-items-center justify-content-between cursor-pointer w-100 mt-2' onClick={() => setOpen(!open)}>
                            <InputGroup className='container-relative input-main'>
                                <InputGroup.Text>R$</InputGroup.Text>
                                <CurrencyInput
                                    id="input-example"
                                    name="input-name"
                                    className='form-control input-main'
                                    intlConfig={{ locale: 'pt-BR' }}
                                    placeholder="0,00"
                                    value={budget ? budget : 0}
                                    onBlur={setZeroForAll}
                                    onClick={(e: any) => e.stopPropagation()}
                                    decimalsLimit={2}
                                    onValueChange={(value: any, name: any) => setBudget(value ? value : 0)}
                                />
                            </InputGroup>
                            {open ?
                                <FaChevronUp className="font-awesome-icon" />
                                :
                                <FaChevronDown className="font-awesome-icon" />
                            }
                        </div>
                        <Collapse in={open} className="background-collapse">
                            <div id="collapse" className='p-3'>
                                <div className='d-flex align-items-center'>
                                    <div className="w-100 me-3">
                                        <label>Recursos Humanos:</label>
                                        <InputGroup className='container-relative w-100'>
                                            <InputGroup.Text>R$</InputGroup.Text>
                                            <CurrencyInput
                                                id="input-example"
                                                name="input-name"
                                                className='form-control'
                                                intlConfig={{ locale: 'pt-BR' }}
                                                placeholder="0,00"
                                                value={RhValue ? RhValue : 0}
                                                onBlur={sumBudget}
                                                onClick={(e: any) => e.stopPropagation()}
                                                decimalsLimit={2}
                                                onValueChange={(value: any, name: any) => setRhValue(value ? value : 0)}
                                            />
                                        </InputGroup>
                                    </div>
                                    <div className="w-100 ms-3">
                                        <label>Infraestrutura:</label>
                                        <InputGroup className='container-relative w-100'>
                                            <InputGroup.Text>R$</InputGroup.Text>
                                            <CurrencyInput
                                                id="input-example"
                                                name="input-name"
                                                className='form-control'
                                                intlConfig={{ locale: 'pt-BR' }}
                                                placeholder="0,00"
                                                value={infraValue ? infraValue : 0}
                                                onBlur={sumBudget}
                                                onClick={(e: any) => e.stopPropagation()}
                                                decimalsLimit={2}
                                                onValueChange={(value: any, name: any) => setInfraValue(value ? value : 0)}
                                            />
                                        </InputGroup>
                                    </div>
                                </div>
                                <div className='d-flex align-items-center mt-4'>
                                    <div className="w-100 me-3">
                                        <label>Serviços de Terceiros:</label>
                                        <InputGroup className='container-relative w-100'>
                                            <InputGroup.Text>R$</InputGroup.Text>
                                            <CurrencyInput
                                                id="input-example"
                                                name="input-name"
                                                className='form-control'
                                                intlConfig={{ locale: 'pt-BR' }}
                                                placeholder="0,00"
                                                value={invoicesValue ? invoicesValue : 0}
                                                onBlur={sumBudget}
                                                onClick={(e: any) => e.stopPropagation()}
                                                decimalsLimit={2}
                                                onValueChange={(value: any, name: any) => setInvoicesValue(value ? value : 0)}
                                            />
                                        </InputGroup>
                                    </div>
                                    <div className="w-100 ms-3">
                                        <label>Aquisição de Equipamentos (Nacional ou Importado):</label>
                                        <InputGroup className='container-relative w-100'>
                                            <InputGroup.Text>R$</InputGroup.Text>
                                            <CurrencyInput
                                                id="input-example"
                                                name="input-name"
                                                className='form-control'
                                                intlConfig={{ locale: 'pt-BR' }}
                                                placeholder="0,00"
                                                value={equipmentValue ? equipmentValue : 0}
                                                onBlur={sumBudget}
                                                onClick={(e: any) => e.stopPropagation()}
                                                decimalsLimit={2}
                                                onValueChange={(value: any, name: any) => setEquipmentValue(value ? value : 0)}
                                            />
                                        </InputGroup>
                                    </div>
                                </div>
                            </div>
                        </Collapse>
                    </div>
                    <div className='border-round card-header d-flex align-items-center w-100 mt-2 mb-4'>
                            <label className="required">Projeto em Andamento? </label>
                            <select
                                value={inProgress.toString()}
                                onChange={(e) => {
                                    if (project.inProgress && inProgress) {
                                        setChanging("progress");
                                        setChangingValue(e);
                                    } else {
                                        setInProgress(JSON.parse(e.target.value))
                                    }
                                }}
                                className="form-select w-25 ms-3"
                            >
                                <option value="false">Não</option>
                                <option value="true">Sim</option>
                            </select>
                        </div>

                    <div className='border-round card-header d-flex align-items-center w-100 mt-2 mb-4'>
                        <label className="required">Elegível para Financiamento? </label>

                        <Select
                            value={eligible}
                            className="w-25 ms-3"
                            options={AllEligibleType}
                            onChange={(e: any) => {
                                if (project.eligibleType == 0 && eligibleText == "eligible") {
                                    setChanging("eligible");
                                    setChangingValue(e);
                                } else {
                                    setEligible(e);
                                    setEligibleText(e.value)
                                }
                            }}
                            classNamePrefix="select"
                            isDisabled={!CanView}
                        />
                    </div>
                    <Button variant="contained" color="secondary" type='button' onClick={Submit} className='btn btn-primary w-100 mb-3 mt-4'>
                        Salvar Projeto
                    </Button>
                </form>
            </div>
        </div>
    )
}

export default EditProjectHistory;